import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import styles from './ConsentDisclaimer.module.css';

const CONSENT_ITEMS = [
  { key: 'platform', label: 'I understand that Oval Care is a technology platform and not a medical provider' },
  { key: 'providerResponsibility', label: 'I understand that the healthcare provider is solely responsible for my medical care' },
  { key: 'prescriptionNotGuaranteed', label: 'I understand that a prescription is not guaranteed and is subject to the provider\'s medical judgment' },
  { key: 'medicationRisks', label: 'I acknowledge the risks associated with medications, including potential side effects' },
  { key: 'termsAndPrivacy', label: 'I have read and agree to the Terms of Service and Privacy Policy' },
];

const initialState = Object.fromEntries(CONSENT_ITEMS.map(({ key }) => [key, false]));

const ConsentDisclaimer = ({ className, onChange }) => {
  const [checks, setChecks] = useState(initialState);

  const allChecked = CONSENT_ITEMS.every(({ key }) => checks[key]);

  useEffect(() => {
    if (onChange) {
      onChange({ ...checks, allChecked });
    }
  }, [checks, allChecked, onChange]);

  const handleToggle = useCallback((key) => {
    setChecks((prev) => ({ ...prev, [key]: !prev[key] }));
  }, []);

  return (
    <div className={`${styles.disclaimer}${className ? ` ${className}` : ''}`}>
      <p className={styles.disclaimerText}>
        As part of our efforts to ensure patient safety we need to verify your phone
        number. By giving us your phone number and continuing you agree that Oval Care Inc may
        send text messages to you to verify your phone number and for any other
        lawful purpose related to your Oval Care Inc account and your use of our services
        including order confirmations shipment notifications and messages from your
        provider. Message and data rates may apply. Message frequency varies. Reply
        HELP for help. Reply STOP to opt out.
      </p>
      <p className={styles.policyLinks}>
        Read Oval Care Inc&apos;s{' '}
        <Link to="/terms" className={styles.policyLink}>text policy</Link>
        {' '}and{' '}
        <Link to="/privacy" className={styles.policyLink}>privacy policy</Link>.
      </p>
      {onChange && (
        <div className={styles.checkboxSection}>
          {CONSENT_ITEMS.map(({ key, label }) => (
            <label key={key} className={styles.checkboxLabel}>
              <input
                type="checkbox"
                checked={checks[key]}
                onChange={() => handleToggle(key)}
                className={styles.checkbox}
              />
              <span className={styles.checkboxText}>{label}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default ConsentDisclaimer;
